import { render, staticRenderFns } from "./WallpaperItem.vue?vue&type=template&id=45b223da&scoped=true&"
import script from "./WallpaperItem.vue?vue&type=script&lang=js&"
export * from "./WallpaperItem.vue?vue&type=script&lang=js&"
import style0 from "./WallpaperItem.vue?vue&type=style&index=0&id=45b223da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b223da",
  null
  
)

export default component.exports